import { render, staticRenderFns } from "./CommissionRuleInput.vue?vue&type=template&id=d932b20e"
import script from "./CommissionRuleInput.vue?vue&type=script&lang=js"
export * from "./CommissionRuleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports